import i18n from "i18next";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import { PanelSubNav } from "../../Layout/Panel";
import ViewTypes from "../ViewTypes";

export default class SubNav extends PureComponent {
  static propTypes = {
    onToggleOrderView: PropTypes.func.isRequired,
    activeSubNav: PropTypes.string
  };

  static defaultProps = {
    activeSubNav: ""
  };

  handleToggleProductsView = () => this.props.onToggleOrderView(true);

  handleToggleLoadsView = () => this.props.onToggleOrderView(false);

  subNavs = [
    {
      key: ViewTypes.Products,
      label: i18n.t("accordion.products"),
      onClick: this.handleToggleProductsView
    },
    {
      key: ViewTypes.Loads,
      label: i18n.t("accordion.loads"),
      onClick: this.handleToggleLoadsView
    }
  ];

  render() {
    return <PanelSubNav subNavs={this.subNavs} activeSubNav={this.props.activeSubNav} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/PurchaseOrder/OrderPage/SubNav.js